module.exports = __webpack_public_path__ + "img/sz.e8875051.svg";